export default "__VITE_PUBLIC_ASSET__9ce68a6f__"